import { useLocation } from 'react-router-dom';

// Constants
import { LEND_ROUTE } from 'Constants/navigation';

const useIsMarketingPage = () => {
  const location = useLocation();

  if (location.pathname === LEND_ROUTE) return false;

  const isMarketingPage = location.pathname === '/';

  return isMarketingPage;
};

export default useIsMarketingPage;
